import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    keepaliveUrl: String,
    logoutUrl: String,
    timeout: { type: Number, default: 5 * 60 * 1000 },
    keepaliveInterval: { type: Number, default: 2 * 60 * 1000 }
  }

  connect() {
    this.activeSinceLastKeepalive = false

    this.recordActivity = this.recordActivity.bind(this)
    this.checkIdleTimeout = this.checkIdleTimeout.bind(this)
    this.sendKeepaliveIfActive = this.sendKeepaliveIfActive.bind(this)

    this.activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, this.recordActivity, { passive: true })
    })

    this.recordActivity()

    this.keepaliveTimer = setInterval(
      this.sendKeepaliveIfActive,
      this.keepaliveIntervalValue
    )

    this.idleTimer = setInterval(this.checkIdleTimeout, 10 * 1000)
  }

  disconnect() {
    this.activityEvents.forEach((eventName) => {
      window.removeEventListener(eventName, this.recordActivity)
    })

    clearInterval(this.keepaliveTimer)
    clearInterval(this.idleTimer)
  }

  get activityEvents() {
    return [
      'keydown',
      'mousedown',
      'mousemove',
      'scroll',
      'touchstart'
    ]
  }

  recordActivity() {
    const timestamp = Date.now()

    localStorage.setItem('lastActivityAt', timestamp)
    this.activeSinceLastKeepalive = true
  }

  async sendKeepaliveIfActive() {
    if (!this.activeSinceLastKeepalive) return

    this.activeSinceLastKeepalive = false

    const response = await fetch(this.keepaliveUrlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    })

    if (response.status === 401) {
      this.logout()
    }
  }

  checkIdleTimeout() {
    const lastActivityAt = Number(localStorage.getItem('lastActivityAt'))

    if (!lastActivityAt) return

    if (Date.now() - lastActivityAt >= this.timeoutValue) {
      this.logout()
    }
  }

  logout() {
    window.location.href = this.logoutUrlValue
  }
}
